import { RouteConfig } from "vue-router";
import { login } from "./login";
import { navigate } from "./navigate";

export const embedded = (): Array<RouteConfig> => [...login(), ...navigate()];
